import { Box } from '@mui/material';
import { colors, IconButton, Typography } from '@sweep-io/sweep-design';
import { Close, ArrowBendDownRight } from '@sweep-io/sweep-design/dist/icons';

const SelectedTextBox = ({
  selectedText,
  onCloseClick,
}: {
  selectedText: string;
  onCloseClick: () => void;
}) => (
  <Box
    sx={{
      display: 'flex',
      backgroundColor: colors.grey[150],
      borderRadius: '8px',
      marginBottom: '16px',
      wordBreak: 'break-word',
      width: '100%',
    }}
  >
    <Box p={1.5} height="40px">
      <ArrowBendDownRight color={colors.grey[700]} />
    </Box>
    <Box flex={1} p="12px 0" lineHeight="1.24">
      <Box
        sx={{
          overflow: 'hidden',
          '& .MuiTypography-root': {
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            whiteSpace: 'break-spaces',
            wordBreak: 'break-word',
          },
        }}
      >
        <Typography variant="caption" color={colors.grey[700]} ellipsis>
          {selectedText}
        </Typography>
      </Box>
    </Box>
    <Box p={0.5}>
      <IconButton variant="flat" size="small" onClick={onCloseClick}>
        <Close />
      </IconButton>
    </Box>
  </Box>
);

export default SelectedTextBox;
